import type { OrganizationMember } from "@common/dto/organization/organization-member.dto";
import { useCurrentOrganizationMembers } from "@api/organizationMember.api";

/** The organization member who applied the work and the name to show for them ("Unknown" when not a member); undefined until members load. */
export const getAppliedByMember = ({
    members,
    userId,
}: {
    members: readonly OrganizationMember[] | undefined;
    userId: number;
}): { member: OrganizationMember | undefined; name: string } | undefined => {
    if (!members) {
        return undefined;
    }
    const member = members.find(({ user }) => user.id === userId);
    return {
        member,
        name: member
            ? (member.user.preferredName ?? member.user.name)
            : "Unknown",
    };
};

/** `getAppliedByMember` over the organization's members query. */
export const useAppliedByMember = (userId: number) => {
    const { data: members } = useCurrentOrganizationMembers();
    return getAppliedByMember({ members, userId });
};
